import { render, staticRenderFns } from "./ProjectContactModal.vue?vue&type=template&id=66f85848&scoped=true&"
import script from "./ProjectContactModal.vue?vue&type=script&lang=js&"
export * from "./ProjectContactModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectContactModal.vue?vue&type=style&index=0&id=66f85848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f85848",
  null
  
)

export default component.exports